// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import CarouselStimulusController from './components/stimulus_carousel.js';
import PoliticalExpositionController from './political_exposition_controller.js';
import TomSelectController from './tom_select_controller.js';
import SidebarController from './sidebar_controller.js';
import LendingTimetableFormController from './lending_time_table_controller.js';
import ComputeTimetableController from './compute_time_table_controller.js';
import NestedFormController from './nested_form_controller.js';
import RedactorController from './redactor_controller.js';
import PasswordVisibilityController from './password_visibility_controller.js';
import ProjectSectionSelectorController from './admin/project_section_selector_controller.js';
import LemonwayIframeController from './users/profile_information/onboarding/lemonway_iframe_controller.js';
import SpecialPurposeVehicleFormController from './admin/special_purpose_vehicle_form_controller.js';
import InvestFormController from './invest_form_controller.js';
import PasswordStrengthController from './password_strength_controller.js';
import FetchProjectsController from './fetch_projects_controller.js';
import CopyToClipboardController from './copy_to_clipboard_controller.js';
import ChartjsController from './chartjs_controller.js';
import DashboardChartsController from './dashboard_charts_controller.js';
import scrollTabsController from './scroll_tabs_controller.js';
import SelectedGraphController from './selected_graph_controller.js';
import TooltipsController from './tooltips_controller.js';

application.register('carousel-stimulus', CarouselStimulusController);
application.register('political-exposition', PoliticalExpositionController);
application.register('tom-select', TomSelectController);
application.register('sidebar', SidebarController);
application.register('lending-timetable-form', LendingTimetableFormController);
application.register('compute-timetable', ComputeTimetableController);
application.register('nested-form', NestedFormController);
application.register('redactor', RedactorController);
application.register('password-visibility', PasswordVisibilityController);
application.register(
  'project-section-selector',
  ProjectSectionSelectorController
);
application.register('lemonway-iframe', LemonwayIframeController);
application.register(
  'special-purpose-vehicle-form',
  SpecialPurposeVehicleFormController
);
application.register('invest-form', InvestFormController);
application.register('password-strength', PasswordStrengthController);
application.register('fetch-projects', FetchProjectsController);
application.register('copy-to-clipboard', CopyToClipboardController);
application.register('chartjs', ChartjsController);
application.register('dashboard-charts', DashboardChartsController);
application.register('scroll-tabs', scrollTabsController);
application.register('selected-graph', SelectedGraphController);
application.register('tooltips', TooltipsController);
